import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild, ViewChildren, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SnotifyService } from 'ng-snotify';
import { Subject ,  forkJoin } from 'rxjs';
import { Config } from '../../config/config';
import { LocalstorageService } from '../../service/localstorage.service';
import { RestDataService } from '../../service/rest-data.service';
import { SharedDataService } from '../../service/shared-data.service';
import { StaticDataService } from '../../service/static-data.service';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'youtube-listing',
  templateUrl: './youtube-listing.component.html',
  styleUrls: ['./youtube-listing.component.css']
})

export class YoutubeListingComponent implements OnInit {
    @ViewChild('clipboardInput',{static: false}) clipboardInput: ElementRef;
    @Input() isSelectionOn: boolean;
    @Input() isVideoStoryListing: boolean;
    @Output() sendIdVieoToParentfn = new EventEmitter<any>();
    by_Author;
    getDataUrl = '';
    searchUrl = '';
    metaDataUrl = '';
    @ViewChild('listingInput',{static: false}) searchInput: ElementRef;
    socketsAllowed = [];
    filterList = [];
    facets = null;
    pageNum = 0;
    listArray = [];
    listIdArray = [];
    noresults = false;
    private stompClient;
    pageSize = 50;
    pageSizeArray = [50, 100, 150, 200];
    sortByValueOf = null;
    exactMatch = false;
    filterUrl = {};
    fields = '';
    initialUrl = '';
    latestUrl = '';
    callFail = false;
    pages = 0;
    totalRecords = 0;
    str = '';
    searchFocus = false;
    searchQuery: FormControl = new FormControl();
    @ViewChildren('listingInput') searchField;
    showMore = false;
    headerList = [];
    routeLinkForList;
    monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    @ViewChildren('listData2') listData: ElementRef;
    timings = {
      constr: 0,
      onin: 0,
      resp: 0,
      list: 0,
      getEnv: 0,
      getMeta: 0
    };
    videoList = [];
    multiList = [];
    domainConfig = null;
    videoFeedDomains = null;
    private subject: Subject<string> = new Subject();
    embedCode = '';
    videDesc = null;
    videoCreated = null;
    tags = null;
    videoSummary = null;
    videoChannel = null;
    videoLeadImage = null;
    videoDuration = null;
    videoUrl = '';
    openVideoPreview = false;
    iframeStyle = null;
    previewUrl = null;
    isVideoModal = false;
    previewPlatform = null;
    iframeLoading = 0;
    selectedItem = 'gridView';
    viewObject = null;
    unlockOptions = null;
    unlockPopup = false;
    lockedUser = '';
    lockedId = null;
    pageToken: any;
    crossDomains = null;
    domainId = null;
    showLoader = false;
    // private http: HttpClient;
    constructor(
      private config: Config,
      private restService: RestDataService,
      private snotify: SnotifyService,
      private sharedService: SharedDataService,
      private router: Router,
      private sanitizer: DomSanitizer,
      private _http: HttpClient,
      private localstorageService:LocalstorageService
      // handler: HttpBackend
    ) {
      this.timings.constr = performance.now();
      console.log('constructor => 0');
      this.sharedService.getCurrentDomainConfig(this.getDomainConfig.bind(this));
    }
  
    getDomainConfig(currentDomainConfig) {
      // console.log(currentDomainConfig);
      this.domainConfig = currentDomainConfig;
      this.videoFeedDomains = (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['videoFeed'] && this.domainConfig['config']['videoFeed']['domains']
        && this.domainConfig['config']['videoFeed']['domains'].trim() !== '') ?
        this.domainConfig['config']['videoFeed']['domains'].trim() : 'HT,LM';
        this.crossDomains =  (this.domainConfig && this.domainConfig['config']
        && this.domainConfig['config']['video'] && this.domainConfig['config']['video']['ytcrossdomains']) ? 
        this.domainConfig['config']['video']['ytcrossdomains'] : null;
    }
    ngOnInit() {
      this.timings.onin = performance.now();
      console.log('oninit => ', performance.now() - this.timings.constr);
  
  
      // CAN'T Fetch more than 50 stories, because youtube wont fetch url for more than 50 at a time
      this.viewObject = StaticViewDataService.VideoStory_listing_View;
      
      this.getDataUrl = this.config.get('product').utilUrl + '/api/cms/youtube/getVideoList?limit=50';
      this.searchUrl = this.config.get('product').utilUrl + '/api/cms/youtube/searchVideo?limit=50';
      this.metaDataUrl = this.config.get('product').baseUrl + this.viewObject.urls.meta;
      this.socketsAllowed = this.viewObject.socketCodes;
      const filters = this.viewObject.filters;
      this.filterList = this.sharedService.getUpdatedFilters(filters);
      this.fields = this.viewObject.fields;
      this.headerList = this.viewObject.headers;
      this.routeLinkForList = this.viewObject.list_router;
  
      this.timings.getEnv = performance.now();
      console.log('getEnv => ', performance.now() - this.timings.onin);
  
  
      if (this.searchInput) {
        this.searchInput.nativeElement.focus();
      }
  
      if (this.viewObject.sortBy) {
        this.sortByValueOf = this.viewObject.sortBy;
      }
  
      if (this.isVideoStoryListing && this.metaDataUrl && this.metaDataUrl.trim() !== '') {
        // this.restService.http_get(this.metaDataUrl)
        //   .subscribe(data => {
        //     this.facets = { ...data, ...this.facets };
        //   });
        let metaData=this.localstorageService.getMetaData();
        console.log('all-video-service-listing.componet metadata',metaData);
        this.facets=metaData;
      } else {
        if (!this.facets) {
          this.facets = {};
        }
        this.facets['sitename'] = {};
        const sites = this.videoFeedDomains.split(',');
        sites.forEach(site => {
          this.facets['sitename'][site] = 1;
        });
      }
      if(this.crossDomains != null)
        {
          let jsonCrossDomains =  JSON.parse(this.crossDomains);
          let crossDomainIds =  Object.keys(jsonCrossDomains);
          let domainIds = [];
          //const domain = sessionStorage.getItem(StaticDataService.domainLiteral);
          crossDomainIds.forEach(e=>{
            // if(e != domain)
            // {
              domainIds.push({"key":e,"value":jsonCrossDomains[e]});
            // }
          })
          this.facets['domains'] = domainIds;
        }
  
      this.timings.getMeta = performance.now();
      console.log('getmeta => ', performance.now() - this.timings.getEnv);
  
  
      //this.searchResults('', 0, this.dataInsertion);
      this.searchQuery.valueChanges
        .pipe(debounceTime(800)
        ,distinctUntilChanged())
        .subscribe(result => {
          this.pageToken = null;
          this.searchResults(result, 0, this.domainId, this.dataInsertion);
        });
    }
  
    searchResults(query, pageToken, domainId, callback) {
      if (query && query.trim() !== '') {
          let url = this.searchUrl;
          if(this.pageToken) {
            url += "&pageToken=" + this.pageToken;
          }
          const querArr = query.split(':');
          if (querArr && querArr.length > 1 && querArr[0].toUpperCase() === 'ID') {
            url += ',id:' + querArr[1].trim();
          } else {
            url += '&query=' + StaticDataService.encodeSpecialChar(query);
          }
          if(this.domainId != null && this.domainId != '')
        {
          url += this.domainId;
        }
          this.callFail = false;
          this.timings['firstGet'] = performance.now();
          console.log('firstGet => ', performance.now() - this.timings.getMeta);
          console.log("URL ===>" , url)
          this.showLoader = true;
          this.restService.http_get(url)
            .subscribe(data => {
              this.showLoader = false;
              this.timings.resp = performance.now();
              console.log('response received => ', performance.now() - this.timings['firstGet']);
              this.pages = data['totalPages'] > 20 ? 20 : data['totalPages'];
              this.totalRecords = data['totalElements'];
              this.topFunction();
              this.callFail = false;
              if(!(this.pageToken)) {
                this.multiList = [];
              }
              this.pageToken = data['nextPageToken']
              this.measureTime(0);
              this.videoList = [];
              this.videoList = data['response'];
            this.multiList = this.createMultipleList(this.videoList);
              // callback(data);
            },
              error => {
                this.callFail = true;
                this.showLoader = false;
                // console.log(error);
              });
      } else {
        this.getDefaultList(pageToken, data => {
          callback(data);
        });
      }
    }
  
    getDefaultList(pageToken, callback) {
        let url = this.getDataUrl;
        if (this.filterUrl) {
          for (const filter in this.filterUrl) {
            if (filter) {
              url += this.filterUrl[filter];
            }
          }
        }
        // if (url.indexOf('sitename') === -1) {
        //   url += '&sitename=' + this.videoFeedDomains;
        // }
        if(pageToken) {
          url += "&pageToken=" + pageToken;
        }
        this.timings['firstGet'] = performance.now();
        console.log('firstGet => ', performance.now() - this.timings.getMeta);
        this.showLoader = true;
        this.restService.http_get(url).subscribe(
          (response) => {
            this.showLoader = false;
            this.timings.resp = performance.now();
            console.log('response received => ', performance.now() - this.timings['firstGet']);
            if(!(pageToken)) {
              this.multiList = [];
            }
            this.videoList = [];
            // this.multiList = [];
            this.videoList = response['response'];
            this.multiList = this.createMultipleList(this.videoList);
            this.totalRecords = response['total_records'];
            this.pageToken = response['nextPageToken'];
            this.pages = Math.ceil(this.totalRecords / 50);
            this.callFail = false;
            this.measureTime(0);
          },
          (error) => {
            console.log(error);
            this.callFail = false;
            this.showLoader = false;
          }
        );
      
    }
  
    createMultipleList(mainList) {
      let a = [];
      if (mainList && mainList.length > 0) {
        for (let i = 0; i < mainList.length; i += 4) {
          if (mainList[i]) {
            a.push(mainList[i]);
          }
          if (mainList[i + 1]) {
            a.push(mainList[i + 1]);
          }
          if (mainList[i + 2]) {
            a.push(mainList[i + 2]);
          }
          if (mainList[i + 3]) {
            a.push(mainList[i + 3]);
          }
        }
        // this.multiList=[];
        if(!this.multiList[0]) {
          this.multiList.push([...a]);
        } else {
          this.multiList[0] =  this.multiList[0].concat(a)
        }
        
      }
      return this.multiList;
    }
  
    dataInsertion = (data) => {
      console.log(data)
      // console.log("Data inserting")
      // const results = data['response'];
      // this.listArray = [];
      // this.listIdArray = [];
      // if (results && results.length > 0) {
      //   this.listArray = results;
      //   this.multiList = this.createMultipleList(this.listArray);
      //   this.pageToken = data['nextPageToken']
      //   this.noresults = false;
      // } else {
      //   this.noresults = true;
      // }
    }
  
    topFunction() {
      document.body.scrollTop = 0; // For Safari
      if (document.getElementsByClassName('contentList') && document.getElementsByClassName('contentList').length > 0) {
        document.getElementsByClassName('contentList')[0].scrollTop = 0; // For Chrome, Firefox, IE and Opera
      }
  
      if (this.isVideoStoryListing || (!this.isVideoStoryListing && this.selectedItem === 'gridView')) {
        if (document.getElementsByClassName('videoslistBlock') && document.getElementsByClassName('videoslistBlock').length > 0) {
          document.getElementsByClassName('videoslistBlock')[0].scrollTop = 0;
        }
      }
    }
  
    arrayOne(n: number) {
      return Array(n);
    }
  
  
    onKeydown(event, input) {
      if (event.key === "Enter") {
        this.pageToken = null;
        this.searchResults(this.str, 0, this.domainId, this.dataInsertion);
      }
      // this.subject.next(input.value);
      // this.searchResults(this.str, this.pageNum, this.dataInsertion);
    }
  
  
    getFilterData(facet_name) {
      if (this.facets && this.facets[facet_name]) {
        return this.facets[facet_name];
      } else {
        return null;
      }
    }
  
    urlUpdate(ev) {
      this.filterUrl[ev.type] = ev.data;
      if(ev.type == 'domains')
    {
      this.domainId = ev.data;
    }
      this.pageNum = 0;
      this.pageToken = null;
      this.searchResults(this.str, this.pageNum, this.domainId, this.dataInsertion);
    }
  
    checkFocusInside(elem) {
      return (elem && elem.contains(document.activeElement));
    }
  
  
    getFullDate(seconds) {
      if (seconds) {
        const date = new Date(seconds);
        return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
          ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
          + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
      } else {
        return 'not present';
      }
    }
  
    getNewTypeDate(datestring) {
      if (datestring) {
        if (typeof datestring === 'string') {
          const dt = new Date(datestring.replace('+0000', 'Z'));
          return this.getFullDate(Math.round(dt.getTime()));
        } else {
          return this.getFullDate(datestring);
        }
      } else {
        return 'not present';
      }
    }
  
    getclassonCondition(lockStatus, storyStatus) {
      let ulClass = null;
      if (lockStatus && storyStatus === 'PUBLISHED') {
        ulClass = 'publishlockedIcon';
      } else if (lockStatus) {
        ulClass = 'lockedIcon icon-lock';
      } else if (storyStatus === 'PUBLISHED') {
        ulClass = 'publishIcon icon-published';
      }
      return ulClass;
    }
  
    measureTime(count) {
      // console.log(this.listData);
      if (this.listData['length'] === this.pageSize) {
        this.timings.list = performance.now();
        console.log('list loaded => ', performance.now() - this.timings.resp);
        console.log('total first load time => ', performance.now() - this.timings.constr);
      } else if (count < 6) {
        setTimeout(e => {
          this.measureTime(++count);
        }, 0);
      }
    }
  
    fetchMore(){
      console.log("infinte")
      if (this.pageToken) {
        // const result = this.str;
        this.searchResults(this.str, this.pageToken, this.domainId, data => {
          if (data && data['response'] && data['response'].length > 0) {
            // this.dataInsertion(data['content']);
            this.multiList = this.createMultipleList(this.listArray);
            this.noresults = false;
          } else {
            this.noresults = true;
          }
        });
      }
    }
  
    onHovering(e) {
      const imglibHeight = e.target.offsetHeight;
      const btnmargin = (imglibHeight - 38) / 2;
      $('.image .hover').css('height', imglibHeight + 'px');
      $('.image .hover button.blue').css('margin-top', btnmargin + 'px');
      $(this).toggleClass('z-high');
    }
  
    sendVideoToParent(video) {
        this.sendIdVieoToParentfn.emit(video);
      }
}
